import { Row, Col, Card } from "react-bootstrap";

const GroupPercentageStats = ({ data = [], rules = [] }) => {
  if (!data?.length) return null;

  // Δημιουργία ασφαλούς ruleMap
  const ruleMap = {};
  rules.forEach((r) => {
    const key = r?.description_name?.toUpperCase();
    if (!key) {
      console.warn("Missing description_name in rule:", r);
      return;
    }
    ruleMap[key] = r.group;
  });

  let totalA = 0;
  let totalB = 0;

  const resolveGroup = (item) => {
    if (item?.group && ["A", "B"].includes(item.group)) {
      return item.group;
    }
    const desc = item?.description_name?.toUpperCase() || "";
    return ruleMap[desc] || "B";
  };

  data.forEach((item) => {
    const group = resolveGroup(item);

    if (group === "A") totalA += item.total_meals;
    else totalB += item.total_meals;
  });

  const total = totalA + totalB;
  const percentA = total === 0 ? 0 : ((totalA / total) * 100).toFixed(1);
  const percentB = total === 0 ? 0 : ((totalB / total) * 100).toFixed(1);

  return (
    <Row className="mt-4 text-center">
      <Col md={6} xs={12}>
        <Card className="shadow-sm p-4" style={{ borderRadius: 16 }}>
          <h5 style={{ fontWeight: 600 }}>Group A</h5>
          <h2 style={{ fontSize: 48, fontWeight: 700, color: "#4e79a7" }}>
            {percentA}%
          </h2>
          <p style={{ margin: 0, color: "gray" }}>{totalA} μερίδες</p>
        </Card>
      </Col>

      <Col md={6} xs={12} className="mt-3 mt-md-0">
        <Card className="shadow-sm p-4" style={{ borderRadius: 16 }}>
          <h5 style={{ fontWeight: 600 }}>Group B</h5>
          <h2 style={{ fontSize: 48, fontWeight: 700, color: "#e15759" }}>
            {percentB}%
          </h2>
          <p style={{ margin: 0, color: "gray" }}>{totalB} μερίδες</p>
        </Card>
      </Col>
    </Row>
  );
};

export default GroupPercentageStats;
